import React, { FunctionComponent } from 'react';

import { useAppSelector } from '../../../hooks';
import { checkUserPermission } from '../../../helper';
import { getConfigState } from '../../../store/ConfigSlice';
import { getAuthState } from '../../../store/AuthSlice';
import { USER_PERMISSION_INDIVIDUALS } from '../../../store/UserSlice';
import AdminRescheduleRequestsPage from './admin/AdminRescheduleRequestsPage';

const RescheduleRequests: FunctionComponent = () => {
  // Store
  const configState = useAppSelector(getConfigState);
  const authState = useAppSelector(getAuthState);

  if (
    configState.adminEditMode &&
    checkUserPermission(authState.user, {
      adminSchedule: [USER_PERMISSION_INDIVIDUALS.ADMIN_SCHEDULE_VIEW],
    })
  ) {
    return <AdminRescheduleRequestsPage />;
  }

  return null;
};

export default RescheduleRequests;
